import { configureStore } from '@reduxjs/toolkit';
import { reducer as auth } from './authentication/slice';
import { reducer as loading } from './containers/AppLoading/slice';
import language from './containers/LanguageProvider/slice';

const { NODE_ENV } = process.env;

export const createAppStore = () =>
	configureStore({
		reducer: {
			auth,
			language,
			loading,
		},
		devTools: NODE_ENV === 'development',
	});

export const store = createAppStore();

export default store;
